<template>
    <div class="circulationBusinessManage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "circulationBusinessManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
